import { apiProvider } from "@/services/utilities/Provider";

const getList = (page = 1, pageSize = 100) => {
    return apiProvider.get(`/Endpoint?page=${page}&pageSize=${pageSize}`)
        .then(result => result.items);
}

const getById = (id) => {
    return apiProvider.get(`/Endpoint/${id}`);
}

const create = (endpoint) => {
    return apiProvider.post(`Endpoint`, endpoint);
}

const update = (endpoint) => {
    return apiProvider.put(`Endpoint/${endpoint.id}`, endpoint);
}

const remove = (id) => {
    return apiProvider.remove(`Endpoint`, id);
}

export default { getList, getById, create, update, remove };
